import { NgModule } from "@angular/core";
import { VisuallyHiddenComponent } from "./components/visually-hidden/visually-hidden.component";
import { A11yTitleDirective } from "./directives/a11y-title.directive";

@NgModule({
  declarations: [A11yTitleDirective, VisuallyHiddenComponent],
  exports: [A11yTitleDirective, VisuallyHiddenComponent],
})
export class UiAccessibilityModule {}
